var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{class:_vm.cls,attrs:{"solo":"","flat":"","hide-details":"","placeholder":_vm.placeholder,"disabled":_vm.disabled,"type":_vm.type,"suffix":_vm.suffix,"readonly":_vm.readonly,"dense":_vm.dense},on:{"keyup":_vm.changeValue},model:{value:(_vm.tmpValue),callback:function ($$v) {_vm.tmpValue=$$v},expression:"tmpValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }